import { useEffect } from 'react';
import { toast } from 'sonner';
import { useAuth } from '@/lib/auth';
import { connectWebSocket, disconnectWebSocket, onNotification } from '@/lib/websocket';
import { getStoredTokens } from '@/lib/api';
import { beepWarning, beepError } from '@/lib/sounds';
import { showNotification, requestNotificationPermission } from '@/lib/push-notifications';

export function useStockAlerts(): void {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;

    const tokens = getStoredTokens();
    if (!tokens) return;

    connectWebSocket(tokens.accessToken);

    // Request notification permission on connect
    requestNotificationPermission();

    const unsubscribe = onNotification((notification) => {
      if (notification.type === 'stock_out') {
        beepError();
        toast.error(notification.title, {
          description: notification.message,
          duration: 8000,
        });
        showNotification(notification.title, { body: notification.message, tag: 'stock-alert' });
      } else if (notification.type === 'stock_low') {
        beepWarning();
        toast.warning(notification.title, {
          description: notification.message,
          duration: 5000,
        });
        showNotification(notification.title, { body: notification.message, tag: 'stock-alert' });
      } else if (notification.type === 'announcement') {
        toast.info(notification.title, {
          description: notification.message,
          duration: 10000,
        });
        showNotification(notification.title, { body: notification.message, tag: 'announcement' });
      }
    });

    return () => {
      unsubscribe();
      disconnectWebSocket();
    };
  }, [isAuthenticated]);
}
